export const faqListCodeSearch = {
  sections: [
    {
      questions: [
        {
          id: 1,
          question: "Comment s'inscrire à l'examen du code de la route en candidat libre ?",
          answer:
            "L'inscription se fait en ligne : vous devez d'abord créer votre dossier et obtenir votre numéro NEPH via le téléservice officiel, puis réserver une session auprès d'un opérateur agréé.",
        },
        {
          id: 2,
          question: "Quels documents sont nécessaires pour l'inscription à l'examen du code ?",
          answer:
            "Vous devez fournir une pièce d'identité valide, une photo conforme, un justificatif de domicile et, selon votre situation, une attestation de recensement ou de participation à la JDC.",
        },
        {
          id: 3,
          question: "Quel est le prix de l'inscription à l'examen du code de la route ?",
          answer:
            'Le tarif officiel du passage de l\'examen du code est fixé à 30 €, quel que soit l\'opérateur choisi. (Source : <a href="https://www.service-public.fr/particuliers/vosdroits/F33694" target="_blank" rel="noopener noreferrer">Service-Public</a>)',
        },
        {
          id: 4,
          question: "Peut-on s'inscrire au code pour la première fois sans auto-école ?",
          answer:
            "Oui, l'inscription en candidat libre permet de passer l'examen sans être inscrit dans une auto-école et de choisir librement votre date et votre centre d'examen.",
        },
        {
          id: 5,
          question: 'Comment se réinscrire au code après un échec ?',
          answer:
            "Après un échec, vous pouvez réserver immédiatement une nouvelle session d'examen. Chaque nouvelle inscription correspond à une nouvelle session payante.",
        },
        {
          id: 6,
          question: "En combien de temps peut-on passer le code après l'inscription ?",
          answer:
            "Selon les disponibilités des centres d'examen, il est généralement possible de passer l'épreuve en quelques jours à quelques semaines après l'inscription.",
        },
        {
          id: 7,
          question: 'Faut-il repasser le code après une annulation ou une perte de permis ?',
          answer:
            "Dans certaines situations (annulation ou invalidation du permis), il peut être obligatoire de repasser l'examen du code. L'inscription se fait alors comme pour tout candidat libre.",
        },
        {
          id: 8,
          question: 'Peut-on modifier la date de son examen du code ?',
          answer:
            'Oui, les opérateurs agréés permettent généralement de modifier ou reporter la date de votre examen directement depuis votre espace de réservation.',
        },
        {
          id: 9,
          question: "À partir de quel âge peut-on s'inscrire à l'examen du code ?",
          answer:
            "L'inscription est possible dès 15 ans en conduite accompagnée et 16 ans en formule classique, conformément à la réglementation nationale.",
        },
        {
          id: 10,
          question: "Comment obtenir rapidement une place pour l'examen du code ?",
          answer:
            "Pour passer le code plus rapidement, il est conseillé de réserver dès l'obtention du NEPH et de consulter régulièrement les disponibilités des centres.",
        },
        {
          id: 11,
          question: "Combien de fois peut-on passer l'examen du code ?",
          answer:
            "Il n'existe pas de limite au nombre de passages. En cas d'échec, vous pouvez vous réinscrire autant de fois que nécessaire.",
        },
        {
          id: 12,
          question: "Peut-on s'inscrire au code même si l'on a déjà eu le permis auparavant ?",
          answer:
            "Oui, les conducteurs ayant perdu leur permis peuvent s'inscrire à nouveau à l'examen du code afin de régulariser leur situation.",
        },
      ],
    },
  ],
};
